import {FunctionComponent} from "react";
import {SimpleAccordion} from "../../../../components/Accordion";
import {useTranslation} from "react-i18next";

const FAQSection: FunctionComponent = () => {
  const {t} = useTranslation();

  const faqs = [
    {
      title: "Prečo si vybrať certifikovaného poradcu?",
      content: "Pri výbere finančného poradcu je dôležité zvážiť jeho skúsenosti, kvalifikáciu a oblasť špecializácie. Odporúčame si prezrieť profil poradcu, jeho registráciu a skontrolovať, či je registrovaný v príslušných orgánoch. Dobrý poradca by mal byť ochotný vysvetliť vám svoj prístup a odpovedať na všetky vaše otázky."
    },
    {
      title: "Akého poradcu potrebujem?",
      content: "Prvá konzultácia zvyčajne slúži na vzájomné spoznanie sa a identifikáciu vašich finančných potrieb. Poradca sa vás opýta na vašu aktuálnu finančnú situáciu, ciele a očakávania. Na základe týchto informácií vám navrhne plán, ako dosiahnuť vaše finančné ciele. Konzultácia je nezáväzná a slúži na to, aby ste sa rozhodli, či chcete s poradcom spolupracovať."
    },
    {
      title: "Čo by som mal hľadať u takého poradcu?",
      content: "Podmienky spolupráce sa líšia podľa jednotlivých poradcov. Niektorí poradcovia pracujú na províznom základe, iní si účtujú poplatky za konzultácie. Odporúčame sa informovať o podmienkach priamo u konkrétneho poradcu. V profile poradcu nájdete kontaktné informácie pre ďalšie otázky."
    }
  ];

  return (
    <div className="mt-12">
      <h3 className="text-2xl text-gray-800 uppercase mb-6 tracking-wide">
        {t('consultantFinder.faqTitle')}
      </h3>
      <div className="border-b border-gray-300">
        {faqs.map((faq, index) => (
          <SimpleAccordion key={index} title={faq.title}>
            <p className="text-gray-600">{faq.content}</p>
          </SimpleAccordion>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
